<template>
    <div>
       <div>
            <ul class="nav nav-pills nav-fill" role="tablist">
                <li class="nav-item">
                    <a 
                        href="#data" 
                        class="nav-link active"
                        id="data-tab"
                        role="tab"
                        aria-controls="data"
                        aria-selected="true"
                        data-toggle="tab"
                    >
                        <i class="fa fa-dropbox"></i>
                        Quotation Packages
                    </a>
                </li>
            </ul>
       </div>
       <div class="tab-content">
            <div class="tab-pane active" id="data" role="tabpanel" aria-labelledby="data-tab">
                <QuotationPricing 
                :productNumber="productNumber"
                :productVendor="productVendor"
                :userEditRight="userEditRight"
                :pricedFromQuote="pricedFromQuote"
                />
            </div>
       </div>       
    </div>
</template>

<script>
import PriceFunctions from "@/components/Admin/PriceFunctions";
import QuotationPricing from "@/components/Admin/QuotationPricing";

export default {
    extends: PriceFunctions,
    components: {
        QuotationPricing,
    },
    props: {
        productNumber: {
            type: Number,
            required: true,
        },
        productVendor: {
            type: String,
            required: true,
        },
        userEditRight: {
            type: Boolean,
            required: true,
        },
        pricedFromQuote: {
            type: Boolean,
            required: true,
        }
    }
}
</script>

<style scoped>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #f05050 !important;
}
.nav-pills .nav-link {
  background-color: #f3f2ee;
}
a {
  color: rgba(0, 0, 0, 0.6);
}
</style>